import { Navigate } from 'react-router';
import useJwtAuth from '@auth/services/jwt/useJwtAuth';

const DEFAULT_REDIRECT_URL = '/dashboard';

/**
 * SmartRedirect component that redirects to the user's first available page
 * based on their navigation permissions instead of a hardcoded route.
 */
function SmartRedirect() {
	const { user } = useJwtAuth();

	const redirectUrl =
		user?.loginRedirectUrl && user.loginRedirectUrl !== '/' ? user.loginRedirectUrl : DEFAULT_REDIRECT_URL;

	return (
		<Navigate
			to={redirectUrl}
			replace
		/>
	);
}

export default SmartRedirect;
